import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
require('moment-timezone');

import Row from '../Row';
import Select from '../Select';

const DatePickerTimeZone = (props) => {
  const { value, onChange, id } = props;
  const currentTimezone = moment.tz.guess();
  const [timeZoneSelected, setTimeZoneSelected] = useState(currentTimezone);
  const [actualDate, setActualDate] = useState(new Date());

  const refreshClock = () => {
    setActualDate(new Date());
  };

  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);

  const dateChange = (all) => {
    const date = moment.tz(all, timeZoneSelected);
    const dateUTC = date.utc().toISOString();
    onChange(id ? { target: { id: id, value: dateUTC } } : dateUTC);
  };

  const listTimezones = moment.tz
    .names()
    .filter((item) => item.includes('US/'))
    .map((item) => ({
      value: item,
      label: `${item}`,
    }));
  const hourTimezone = moment.tz(actualDate, timeZoneSelected);

  return (
    <DatePicker
      id={id}
      selected={moment(value).toDate()}
      onChange={dateChange}
      dateFormat="MM-dd-yyyy hh:mm a"
      showTimeSelect
      shouldCloseOnSelect={false}
    >
      <div
        style={{
          padding: 10,
          borderTopColor: 'black',
          borderTopWidth: 0.25,
        }}
      >
        <Row
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <div>
            <Select
              id="timeZoneSelect"
              onChange={({ target }) => setTimeZoneSelected(target.value)}
              value={timeZoneSelected}
              className="input-underlined"
              options={listTimezones}
              defaultOption={{
                value: currentTimezone,
                label: currentTimezone,
              }}
            />
          </div>
          <p style={{ marginLeft: 20 }}>{hourTimezone?.format('hh:mm:ss a')}</p>
        </Row>
      </div>
    </DatePicker>
  );
};

export default DatePickerTimeZone;

DatePickerTimeZone.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
};

DatePickerTimeZone.defaultProps = {
  value: new Date().toISOString(),
};
